import React from 'react';
import {
  Box,
  Container,
  Typography,
  Divider,
  Paper
} from '@mui/material';
import Grid from "@mui/material/Grid";

const Accountability = "/assets/ABOUT US/Accountability.png"
const Commitment = "/assets/ABOUT US/Commitment.png"
const Reliability = "/assets/ABOUT US/Reliability.png"
const Openness = "/assets/ABOUT US/Openness.png"
const Excellence = "/assets/ABOUT US/Excellence.png"

const clientImages = [
  "/assets/ABOUT US/clients/client1.jpg",
  "/assets/ABOUT US/clients/client2.jpg",
  "/assets/ABOUT US/clients/client3.jpg",
  "/assets/ABOUT US/clients/client4.jpg",
  "/assets/ABOUT US/clients/client5.jpg",
  "/assets/ABOUT US/clients/client6.jpg",
  "/assets/ABOUT US/clients/client7.jpg",
  "/assets/ABOUT US/clients/client8.jpg",
  "/assets/ABOUT US/clients/client9.jpg",
  "/assets/ABOUT US/clients/client10.jpg",
]

const sectionStyle = theme => ({
  py: 16,
  '&:nth-of-type(even)': {
    bgcolor: theme.palette.primary.main,
    color: theme.palette.secondary.main
  },
  '&:nth-of-type(odd)': {
    bgcolor: "#fff",
    color: theme.palette.secondary.light

    // bgcolor: theme.palette.secondary.main,
    // color: theme.palette.primary.main
  },
  '& p': {
    letterSpacing: "1px",
    fontWeight: 200,
    lineHeight: 1.75,
    textAlign: "center"
  },
  '& img': {
    width: "5vw"
  }
});

const contentStyle = {
  maxWidth: '800px',
  mx: 'auto',
  px: 3,
};

const AboutPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: 8,
        pb: 6,
      }}
    >
        {/* History Section */}
        <Box component="section" sx={sectionStyle}>
          <Container maxWidth="lg" sx={contentStyle}>
            <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
              Our History
            </Typography>
            <Typography variant="body1" paragraph>
              Established in 1992 with the focus on Office and Workshop Equipments, PT Acroe Indonesia quickly rose into one of the leading suppliers in those categories.
            </Typography>
            <Typography variant="body1" paragraph>
              Over the time, PT Acroe Indonesia grew and widen its range of products to better cater to the needs of companies and  governmental bodies; From Laboratory Equipments, Electronics and IT Solutions.
            </Typography>
            <Typography variant="body1" paragraph>
              Started from an empty office, now PT Acroe Indonesia is a one - stop solution for all your needs!
            </Typography>
            <Typography variant="body1" paragraph sx={{ pt: 4 }}>
              Didirikan pada tahun 1992 dengan fokus pada Peralatan Kantor dan Pabrik, PT Acroe Indonesia dengan cepat berkembang menjadi salah satu pemasok terkemuka dalam kategori tersebut.
            </Typography>
            <Typography variant="body1" paragraph>
              Seiring waktu, PT Acroe Indonesia tumbuh dan memperluas jangkauan produknya untuk lebih memenuhi kebutuhan perusahaan maupun instansi pemerintah; mulai dari Peralatan Laboratorium, Elektronik hingga Solusi Teknologi Informasi.
            </Typography>
            <Typography variant="body1" paragraph>
              Berawal dari sebuah kantor kosong, kini PT Acroe Indonesia telah menjadi solusi terpadu untuk semua kebutuhan Anda!
            </Typography>
          </Container>
        </Box>

        {/*<Divider />*/}

        {/*/!* Why Us Section *!/*/}
        {/*<Box component="section" sx={sectionStyle}>*/}
        {/*  <Container maxWidth="lg" sx={contentStyle}>*/}
        {/*    <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>*/}
        {/*      Why Choose Us*/}
        {/*    </Typography>*/}
        {/*    <Typography variant="body1" paragraph>*/}
        {/*      We pride ourselves on our commitment to quality, customer satisfaction, and innovative solutions.*/}
        {/*      Our team of experts brings years of experience and a passion for excellence to every project.*/}
        {/*      We believe in building lasting relationships with our clients through transparency and exceptional service.*/}
        {/*    </Typography>*/}
        {/*  </Container>*/}
        {/*</Box>*/}

        {/*<Divider />*/}

        {/* Values Section */}
        <Box component="section" sx={sectionStyle}>
          <Container maxWidth="lg" sx={contentStyle}>
            <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
              Our Values
            </Typography>
            <Box sx={{ display: "flex", width: "100%" }}>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", pr: 10 }}>
                <img src={Accountability}  alt={"Accountability"}/>
                <Typography variant="header" paragraph>
                  A - Accountable
                </Typography>
                <Typography variant="body1" paragraph>
                  We deliver on promises, learn from mistakes and hold ourselves to the highest standard
                </Typography>
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", pr: 10 }}>
                <img src={Commitment}  alt={"Commitment"}/>
                <Typography variant="header" paragraph>
                  C - Commitment
                </Typography>
                <Typography variant="body1" paragraph>
                  We are committed in maintaining quality and reliability, both in our products and services
                </Typography>
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", pr: 10 }}>
                <img src={Reliability}  alt={"Reliability"}/>
                <Typography variant="header" paragraph>
                  R - Reliability
                </Typography>
                <Typography variant="body1" paragraph>
                  The core value of our products which is the reason ACROE is still widely used in both office and industrial sector
                </Typography>
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", pr: 10 }}>
                <img src={Openness}  alt={"Openness"}/>
                <Typography variant="header" paragraph>
                  O - Openness
                </Typography>
                <Typography variant="body1" paragraph>
                  We believe in the importance of communication and transparency, leading to a robust and lasting relations with our stakeholders
                </Typography>
              </Box>

              <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img src={Excellence}  alt={"Excellence"}/>
                <Typography variant="header" paragraph>
                  E - Excellence
                </Typography>
                <Typography variant="body1" paragraph>
                  We create nothing but excellence in terms of both products and services
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>

        {/*<Divider />*/}

        {/* Our Clients Section */}
        <Box component="section" sx={sectionStyle}>
          <Container maxWidth="lg" sx={contentStyle}>
            <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 4 }}>
              Our Clients
            </Typography>
            <Grid container spacing={4} justifyContent={"center"} alignItems={"center"}>
              {
                clientImages.map((img, index) =>
                  <Grid item xs={3} key={index}>
                    <img src={img} alt={"client"} style={{ width: "100%" }} />
                  </Grid>
                )
              }
            </Grid>

          </Container>
        </Box>
    </Box>
  );
};

export default AboutPage;
